<template>
  <div>
    <div class="doctorInfoBox" v-if="$vuetify.breakpoint.mdAndUp">
      <div class="extendableArea">
        <div class="d-flex" @click="returnBack">
          <div class="arrowBack" >
            <img src="../../assets/image/user-journey/arrow-narrow-right.svg" alt="">
          </div>
          <div class="mr-2 d-flex flex-column justify-center arrowBackText">
            بازگشت به لیست
          </div>
        </div>
        <div class="personalInfoDoctor text-center mt-1">
          <img :src="therapist.user.avatar" width="135" alt="">
          <div class="nameDoctor">
            دکتر
            {{ therapist.user.full_name }}
          </div>
          <div class="titleDoctor">
            {{ therapist.subtitle }}
          </div>
        </div>
        <div class="overviewBox mb-5">
          <div class="d-flex justify-space-between">
            <v-row>
              <v-col cols="12" lg="4" class="pa-0 ma-0">
                <div class="overviewItem text-center " style="border-left: 1px solid #EAF0F6">
                  <img src="../../assets/image/user-journey/star-filled.svg" alt="">
                  <div class="overviewItemTextArea d-flex justify-center ">
                    <div class="scoreOverview d-flex flex-column justify-center">
                      {{ therapist.rating }}
                    </div>
                    <div class="titleOverview mt-1 mr-1">
                      امتیاز
                    </div>
                  </div>

                </div>
              </v-col>
              <v-col cols="12" lg="4" class="pa-0 ma-0">
                <div class="overviewItem text-center " style="border-left: 1px solid #EAF0F6">
                  <img src="../../assets/image/user-journey/video_icon.svg" alt="">
                  <div class="overviewItemTextArea d-flex justify-center ">
                    <div class="scoreOverview" style="direction: ltr">
                      +

                      {{ Number(therapist.held_sessions).toLocaleString() || '—' }}
                    </div>
                    <div class="titleOverview mr-1">
                      جلسه
                      موفق
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" lg="4" class="pa-0 ma-0">
                <div class="overviewItem text-center ">
                  <img src="../../assets/image/user-journey/thumb-up-filled_2.svg" alt="">
                  <div class="overviewItemTextArea d-flex justify-center ">
                    <div class="scoreOverview" style="direction: ltr">
                      {{ therapist.user_suggestion }}%
                    </div>
                    <div class="titleOverview mr-1">
                      پیشنهاد کاربران
                    </div>
                  </div>

                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <v-tabs
            v-model="tab"
            fixed-tabs
            class="pa-0 ma-0"
            color="#30A778"
        >
          <v-tab color="pa-0 ma-0" value="morning">رزومه تراپیست</v-tab>
          <v-tab color="pa-0 ma-0" value="evening">آخرین نظرات کاربران</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item :value="0">
            <div class="specialityDoctor">
              <div class="titleSection">
                حوزه‌های تخصصی
              </div>
              <div class="d-flex flex-wrap" style="margin-top: 16px">
                <div class="specialityItem" v-for="(item , i) in therapist.therapeutic_subjects.slice(0, 5)" :key="i">
                  {{ item.title }}
                </div>
              </div>
            </div>
            <div class="resumeHtml">
              <div class="mt-5">
                <div v-html="therapist.resume_html"></div>
              </div>
            </div>
          </v-tab-item>
          <v-tab-item :value="1" v-if="therapist.reviews">
            <div class="feedbackArea" :style="`overflow: ${isOpen ? 'auto' : 'hidden'}`">
              <div class="feedbackItem" v-for="(item ,i) in therapist.reviews" :key="i">
                <div class="headerFeedback">
                  <div class="feedbackClientName">
                    مراجع مشاورلایو
                  </div>
                  <div class="d-flex">
                    <div class="rateScore">
                      {{ item.rate }}
                    </div>
                    <div>
                      <img width="20" src="../../assets/image/user-journey/star-filled.svg" alt="">
                    </div>
                  </div>
                </div>
                <div class="feedbackContent">
                  {{ item.message }}
                </div>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <div class="text-center">
        <v-btn text color="#035184" class="loadMore" @click="changeStateDetail">
          <template v-if="!isOpen">
            اطلاعات بیشتر
          </template>
          <template v-else>
            اطلاعات کمتر
          </template>
          <img class="mr-2" :style="!isOpen && 'transform: rotate(180deg)'"
               src="../../assets/image/user-journey/chevron-up.svg" alt="">
        </v-btn>
      </div>
    </div>
    <div v-else>
      <div class="doctorInfoBoxMobile mt-4">
        <div class="d-flex">
          <div class="d-flex flex-column justify-center">
            <img :src="therapist.user.avatar" width="85px" alt="">
          </div>
          <div class="d-flex justify-center flex-column">
            <div class="nameDoctor">
              دکتر
              {{ therapist.user.full_name }}
            </div>
            <div class="subtitle">
              {{ therapist.subTitle }}
              دکتری تخصصی روانشناسی بالینی
            </div>
          </div>
        </div>
        <div class="overviewBox">
          <div class="d-flex justify-space-between">
            <v-row>
              <v-col cols="4" class="pa-0 ma-0">
                <div class="overviewItem text-center " style="border-left: 1px solid #EAF0F6">
                  <img src="../../assets/image/user-journey/star-filled.svg" alt="">
                  <div class="overviewItemTextArea d-flex justify-center ">
                    <div class="scoreOverview">
                      {{ therapist.rating }}
                    </div>
                    <div class="titleOverview mt-1 mr-1">
                      امتیاز
                    </div>
                  </div>

                </div>
              </v-col>
              <v-col cols="4" class="pa-0 ma-0">
                <div class="overviewItem text-center " style="border-left: 1px solid #EAF0F6">
                  <img src="../../assets/image/user-journey/video_icon.svg" alt="">
                  <div class="overviewItemTextArea d-flex justify-center ">
                    <div class="scoreOverview" style="direction: ltr">
                      +
                      {{ Number(therapist.held_sessions).toLocaleString() || '—' }}
                    </div>
                    <div class="titleOverview mr-1">
                      جلسه
                      موفق
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="4" class="pa-0 ma-0">
                <div class="overviewItem text-center ">
                  <img src="../../assets/image/user-journey/thumb-up-filled_2.svg" alt="">
                  <div class="overviewItemTextArea d-flex justify-center ">
                    <div class="scoreOverview" style="direction: ltr">
                      {{ therapist.user_suggestion }}%
                    </div>
                    <div class="titleOverview mr-1">
                      پیشنهاد کاربران
                    </div>
                  </div>

                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="actionDoctor d-flex justify-end">
          <div class="d-flex" @click="resumeSheet = true">
            <div>
              مشاهده رزومه و نظرات
            </div>
            <div>
              <img src="../../assets/image/user-journey/chevron-left_1.svg">
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-bottom-sheet style="border-radius: 16px 16px 0px 0px " v-model="resumeSheet" fullscreen height="100%" scrollable>

      <div class="resume-sheet" style="border-radius: 16px 16px 0px 0px">
        <div class="headerResume  pt-3">
          <div class="d-flex">
            <div class="d-flex flex-column justify-center">
              <img src="../../assets/image/user-journey/arrow-narrow-right-black.svg"
                   @click="resumeSheet = !resumeSheet" alt="">
            </div>
            <div class="flex-grow-1 mr-2 titleHeader">
              دکتر
              {{ therapist.user.full_name }}
            </div>
          </div>
        </div>
        <div class="sheet-scroll  " id="sheetScroll">
          <v-tabs
              v-model="tab"
              fixed-tabs
              class="pa-0 ma-0 tabs-sticky"
              color="#30A778"
          >
            <v-tab color="pa-0 ma-0" value="morning">رزومه تراپیست</v-tab>
            <v-tab color="pa-0 ma-0" value="evening">آخرین نظرات کاربران</v-tab>
          </v-tabs>
          <v-tabs-items class="" v-model="tab" :class="tab == 1 && 'fill-height'">
            <v-tab-item :value="0">
              <div class="white">
                <div class="detailDoctor">
                  <div class="detailItem">
                    <div class="iconDetail d-flex flex-column justify-center">
                      <img src="../../assets/image/user-journey/brain.svg" alt="">
                    </div>
                    <div class="nameDetail mx-1 d-flex flex-column justify-center">
                      رویکرد:
                    </div>
                    <div class="valueDetail" v-if="therapist.therapeutic_modalities.length">
                      {{ therapist.therapeutic_modalities[0].title_fa }}
                    </div>
                    <div v-else>
                      _
                    </div>
                  </div>
                  <div class="d-flex mt-4">
                    <div class="detailItem ml-15">
                      <div class="iconDetail d-flex flex-column justify-center">
                        <img src="../../assets/image/user-journey/home.svg" alt="">
                      </div>
                      <div class="nameDetail mx-1 d-flex flex-column justify-center">
                        شماره نظام:
                      </div>
                      <div class="valueDetail">
                        {{ therapist.psy_sys_number || '—' }}
                      </div>
                    </div>

                    <div class="detailItem">
                      <div class="iconDetail d-flex flex-column justify-center">
                        <img src="../../assets/image/user-journey/work.svg" alt="">
                      </div>
                      <div class="nameDetail mx-1 d-flex flex-column justify-center">
                        تجربه کاری :
                      </div>
                      <div class="valueDetail">
                        <span style="direction: ltr;display: inline-block">{{ therapist.years_of_experience }}</span>
                        سال
                      </div>
                    </div>

                  </div>
                </div>
                <div class="specialityDoctor">
                  <div class="titleSection">
                     <span class="greenItemDark">
                    حوزه‌های تخصصی
                  </span>
                    {{ therapist.user.full_name }}
                  </div>
                  <div class="d-flex flex-wrap" style="margin-top: 16px">
                    <div class="specialityItem" v-for="(item , i) in therapist.therapeutic_subjects.slice(0, 5)"
                         :key="i">
                      {{ item.title }}
                    </div>
                  </div>
                </div>
                <div class="resumeHtmlMobile">
                  <div class="mt-5">
                    <div v-html="therapist.resume_html"></div>
                  </div>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item class="fill-height" v-if="therapist.reviews">
              <div class="feedbackArea fill-height" :style="`overflow: ${isOpen ? 'auto' : 'hidden'}`">
                <div class="feedbackItem" v-for="(item ,i) in therapist.reviews" :key="i">
                  <div class="headerFeedback">
                    <div class="feedbackClientName">
                      مراجع سیمیاروم
                    </div>
                    <div class="d-flex">
                      <div class="rateScore">
                        {{ item.rate }}
                      </div>
                      <div>
                        <img width="20" src="../../assets/image/user-journey/star-filled.svg" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="feedbackContent">
                    {{ item.message }}
                  </div>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>

    </v-bottom-sheet>

  </div>
</template>

<script>

import gsap from 'gsap';

export default {
  props: {
    therapist: Object,
  },
  data() {
    return {
      resumeSheet: false,
      isOpen: false,
      tab: 0
    }
  },
  watch: {
    tab() {

      this.scrollSheetToTop()
    }
  },
  methods: {
    returnBack() {
      this.$emitEvent('goBack')
    },
    changeStateDetail() {
      if (!this.isOpen) {
        gsap.fromTo('.extendableArea', {height: 580}, {
          height: 'auto', 
          ease: 'power2.out',
          onComplete: () => {
            // Scroll to bottom after animation completes
            setTimeout(() => {
              window.scrollTo({
                top: document.body.scrollHeight,
                behavior: 'smooth'
              })
            }, 100)
          }
        })
        this.isOpen = true
      } else {
        gsap.to('.extendableArea', {height: 580, ease: 'power2.out'})
        this.isOpen = false
      }
    },
    scrollSheetToTop() {
      this.$nextTick(() => {
        const container = document.getElementById('sheetScroll')
        container.scrollTo({top: 0, behavior: 'smooth'})
      })
    }
  }
}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 1000px) {
  .feedbackArea {
    height: auto !important;
    padding: 15px 15px !important;
  }

  .nameDoctor {
    font-size: 20px !important;
    text-align: right !important;
    color: #212121;
    margin-bottom: 8px;
  }

  .subtitle {
    font-size: 16px !important;
    text-align: right !important;
  }

  .detailDoctor {
    padding: 16px 24px !important;
  }

  .specialityDoctor {
    padding: 16px 24px !important;
  }

  .resumeHtml {
    padding: 16px 24px !important;
  }

  .resumeHtmlMobile {
    padding: 16px 24px !important;

  }

  .titleSection {
    font-size: 16px !important;
  }

  .resumeHtml {
    padding: 0px 0px 24px 0px;
    //height: 220px !important;
    overflow-y: inherit !important;
    overflow-x: inherit !important;
  }

  .overviewBox {
    margin-bottom: 15px;
    margin-top: 15px;
  }
}

.arrowBackText{
  color: #035184;
  font-weight: 700;
  font-size: 16px;
  cursor: pointer;
}

.titleHeader {
  font-weight: 700;
  font-size: 18px;
}

.feedbackClientName {
  font-weight: 700;
  font-size: 18px;

}

.rateScore {
  font-weight: 500;
  font-size: 18px;
  margin-left: 4px;

}

.headerFeedback {
  display: flex;
  justify-content: space-between;
}

.feedbackContent {
  font-weight: 400;
  font-size: 18px;
  margin-top: 5px;
}

.feedbackArea {
  padding: 16px 5px;
  height: 400px;
}

.feedbackItem {
  margin-bottom: 15px;
  border-bottom: 1px solid #EEEEEE;
  padding-bottom: 10px;
}


.titleHeader {
  font-size: 18px;
  color: #212121;
  font-weight: 700;
}

.headerResume {
  padding: 16px 24px;
  border-bottom: 1px solid var(--Bluegray-bluegray-lighten-2, #EAF0F6);

  position: sticky;
  top: 0;
  background: #FFF;
  z-index: 2;
  margin-bottom: 3px
}

.actionDoctor {
  color: #035184;
  font-size: 16px;
  font-weight: 500;
}


.doctorInfoBoxMobile {
  background: white;
  padding: 10px 16px;
}

.greenItemDark {
  color: #30A778 !important;
}

.doctorInfoBox {
  border-radius: 16px;
  padding: 24px;
  border: 1px solid var(--Bluegray-bluegray-lighten-3, #DBE4ED);
  background: var(--shades-white, #FFF);
}

.subtitle {
  color: #616161;
  text-align: center;
  font-size: var(--Font-Size-xl, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.arrowBack {
  background: #EAF0F6;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  text-align: center;
  cursor: pointer;
}

.extendableArea {
  transition: all 0.3s;
  overflow: hidden;
  height: 590px
}

.loadMore {
  color: #035184;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.specialityItem {
  margin: 0px 0px 16px 8px;
  display: flex;
  height: 32px;
  padding: 0 12px;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: #EAF0F6;
}

.personalInfoDoctor {
  padding-bottom: 16px;
}

.overviewBox {
  border: 1px solid #EAF0F6;
  border-radius: 8px;
  padding: 16px;
}

.detailDoctor {
  padding: 16px 8px 24px 8px;
  border-bottom: 1px solid #EEE;
  background: transparent;
  border-radius: 0px !important;
}

.specialityDoctor {
  padding: 16px 0px 24px 0px;
  border-bottom: 1px solid #EEE;

}

.resumeHtml {
  padding: 0px 0px 24px 0px;
  //height: 250px;
  //overflow-y: auto;
  //overflow-x: hidden;
}

.resumeHtmlMobile {
  padding: 0px 0px 24px 0px;

}

.resume-sheet {
  height: 100vh;
  display: flex;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
  flex-direction: column;
}

.sheet-scroll {
  flex: 1 1 auto;
  overflow-y: auto;
  background: #f6f9fc;
  //background: red;
  -webkit-overflow-scrolling: touch;
}

.specialityDoctor {
  padding: 16px 0px;
}

.nameDoctor {
  color: #212121;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.titleSection {
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.activeTimeItem {
  border-color: #39C990 !important;
  transition: all 0.3s;
}

.scoreOverview {
  font-size: 13px;
  color: #424242;
  font-weight: 700;
}

.titleOverview {
  font-size: 11px;
  font-weight: 600;
  color: #616161;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.overviewItem {
  width: 100%;
  padding: 10px;
}

.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) {
  color: #757575 !important;;
  font-weight: 700;
}

.v-tab--active {
  color: #30A778 !important;
}

.tabs-sticky {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #FFF;
}

</style>